import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { AlertProps } from '@mui/material';
import { Alert } from '@mui/material';
import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

interface OfflineAlertProps extends Pick<AlertProps, 'action'> {
  children: ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px 8px 12px',
    },

    '& .MuiAlert-action': {
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
      },
    },
  },
  message: {
    alignSelf: 'center',
  },
  icon: {
    color: theme.palette.text.primary,
    alignSelf: 'center',
  },
}));

const OfflineAlert = ({ children, action }: OfflineAlertProps) => {
  const { classes } = useStyles();

  return (
    <Alert
      action={action}
      severity="info"
      classes={{ message: classes.message, root: classes.root }}
      iconMapping={{
        info: <InfoOutlined fontSize="small" className={classes.icon} />,
      }}
    >
      {children}
    </Alert>
  );
};

export default OfflineAlert;
